"use client";

import { useAuth } from "@clerk/nextjs";
import { isFeideUserFromSession } from "@/auth/utils";

export const useFeidePurchaseGate = (requiresFeideUser: boolean) => {
  const { isLoaded, isSignedIn, sessionClaims } = useAuth();
  const isFeideUser = isFeideUserFromSession(sessionClaims);

  return {
    // Only a resolved session can block a purchase. While Clerk is loading we
    // don't know yet, so the caller should treat it as pending, not blocked.
    isFeidePurchaseBlocked: requiresFeideUser && isLoaded && !isFeideUser,
    isFeideAuthLoading: requiresFeideUser && !isLoaded,
    shouldShowFeideRequiredInfoBox:
      requiresFeideUser && isLoaded && isSignedIn === true && !isFeideUser,
  };
};
